import React from 'react'

export default function NomadIcon({ className, size = 48 }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 64 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <circle cx="32" cy="32" r="30" fill="url(#nomad-bg)" opacity="0.2" />
      <defs>
        <linearGradient id="nomad-bg" x1="0" y1="0" x2="64" y2="64">
          <stop offset="0%" stopColor="#667eea" />
          <stop offset="100%" stopColor="#764ba2" />
        </linearGradient>
        <linearGradient id="nomad-tent" x1="0" y1="0" x2="64" y2="64">
          <stop offset="0%" stopColor="#667eea" />
          <stop offset="100%" stopColor="#764ba2" />
        </linearGradient>
      </defs>
      
      {/* Палатка кочевника */}
      <path
        d="M32 15L18 38H46L32 15Z"
        fill="url(#nomad-tent)"
        opacity="0.8"
      />
      <path
        d="M32 15L18 38H46L32 15Z"
        stroke="url(#nomad-tent)"
        strokeWidth="2"
        fill="none"
      />
      
      {/* Вход в палатку */}
      <path
        d="M28 38V30C28 28 30 26 32 26C34 26 36 28 36 30V38"
        fill="#1a1a2e"
        opacity="0.3"
      />
      
      {/* Основание */}
      <line x1="16" y1="38" x2="48" y2="38" stroke="url(#nomad-tent)" strokeWidth="2" strokeLinecap="round" />
      
      {/* Декоративные элементы */}
      <circle cx="24" cy="30" r="1.5" fill="#667eea" />
      <circle cx="40" cy="30" r="1.5" fill="#764ba2" />
      <circle cx="32" cy="22" r="1.5" fill="#667eea" />
      
      {/* Тропинка */}
      <path
        d="M32 38V48"
        stroke="url(#nomad-tent)"
        strokeWidth="2"
        strokeLinecap="round"
        opacity="0.5"
      />
    </svg>
  )
}
